export const getPercentage = (current, total) => {
  return Math.round((current / total) * 100)
}
